import { Inertia } from '@inertiajs/inertia'
import React, { useState } from 'react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PaginationList from '../../Shared/Components/PaginationList'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import UserAvatar from '../../Shared/Components/UserAvatar'

function ContactModal({ show, onHide, item }) {
    if (!item) {
        return null
    }

    const fullName = [item.user?.name, item.lastname_ap, item.lastname_am].filter(Boolean).join(' ')

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Información de contacto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center gap-4 mb-6">
                    <UserAvatar src={item.user?.photo_url} size={72} alt={fullName} />
                    <div>
                        <div className="fw-bold text-gray-800 fs-5">{fullName || '—'}</div>
                        <div className="text-muted fs-7">{item.position?.nombre || '—'}</div>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                        <tbody>
                            <tr>
                                <th className="text-gray-500 fw-semibold w-200px">Nombre</th>
                                <td className="text-gray-800 fw-bold">{fullName || '—'}</td>
                            </tr>
                            <tr>
                                <th className="text-gray-500 fw-semibold">Correo electrónico</th>
                                <td className="text-gray-800 fw-bold">{item.user?.email || '—'}</td>
                            </tr>
                            <tr>
                                <th className="text-gray-500 fw-semibold">Teléfono</th>
                                <td className="text-gray-800 fw-bold">{item.phone_number || '—'}</td>
                            </tr>
                            <tr>
                                <th className="text-gray-500 fw-semibold">Medio de contacto</th>
                                <td className="text-gray-800 fw-bold">{item.contact_medium || '—'}</td>
                            </tr>
                            <tr>
                                <th className="text-gray-500 fw-semibold">Oficina</th>
                                <td className="text-gray-800 fw-bold">{item.office?.nombre || '—'}</td>
                            </tr>
                            <tr>
                                <th className="text-gray-500 fw-semibold">Puesto</th>
                                <td className="text-gray-800 fw-bold">{item.position?.nombre || '—'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

const List = ({ items, offices, positions, filters = {}, canExport = false }) => {
    const [search_text, setSearchText] = useState(filters.search || '')
    const [office_id, setOfficeId] = useState(filters.office || '')
    const [position_id, setPositionId] = useState(filters.position || '')
    const [selected, setSelected] = useState(null)

    const paginationFilters = {
        search: search_text || undefined,
        office: office_id || undefined,
        position: position_id || undefined,
    }

    function search() {
        Inertia.get(route('directory.list'), paginationFilters, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
        })
    }

    function exportExcel() {
        // Exporta todo el directorio activo (sin filtros de la pantalla)
        window.location.href = route('directory.export')
    }

    const rows = items.data || []

    return (
        <Row>
            <div className="mb-7 mt-7">
                <Breadcrumbs currentPath="/admin/corporate_structure/directory" />
            </div>

            <Col className="mt-4 mb-2 px-1">
                <h2>Directorio</h2>
                <p className="text-gray-600 mb-0">Consulta de empleados, asesores y personal corporativo activo.</p>
            </Col>

            <Row className="mb-4 px-1">
                <Col xs={12} className="px-1">
                    <div className="d-flex flex-wrap align-items-center">
                        <Form.Control
                            value={search_text}
                            placeholder="Nombre"
                            type="text"
                            onChange={(e) => setSearchText(e.target.value)}
                            className="mx-2 mb-2"
                            style={{ width: '160px' }}
                        />
                        <Form.Select
                            className="form-control mx-2 mb-2"
                            style={{ width: '170px' }}
                            value={office_id}
                            onChange={(e) => setOfficeId(e.target.value)}
                        >
                            <option value="">Todas las oficinas</option>
                            {offices.map((office) => (
                                <option key={office.id} value={office.id}>{office.nombre}</option>
                            ))}
                        </Form.Select>
                        <Form.Select
                            className="form-control mx-2 mb-2"
                            style={{ width: '170px' }}
                            value={position_id}
                            onChange={(e) => setPositionId(e.target.value)}
                        >
                            <option value="">Todas las posiciones</option>
                            {positions.map((position) => (
                                <option key={position.id} value={position.id}>{position.nombre}</option>
                            ))}
                        </Form.Select>
                        <Button onClick={search} variant="primary" className="btn-sm mx-2 mb-2" type="button">
                            Filtrar
                        </Button>
                        {canExport && (
                            <Button onClick={exportExcel} variant="success" className="btn-sm mx-2 mb-2" type="button">
                                Exportar Excel
                            </Button>
                        )}
                        <span className="text-gray-500 fs-8 mx-2 mb-2 align-self-center">
                            El Excel incluye todo el personal activo (encabezados en español).
                        </span>
                    </div>
                </Col>
            </Row>

            <div className="card card-flush h-md-100">
                <div className="card-body pt-6 px-2">
                    <div className="table-responsive mb-4">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 min-w-60px text-start ps-2">FOTO</th>
                                    <th className="p-0 pb-3 min-w-150px text-start ps-2">NOMBRE</th>
                                    <th className="p-0 pb-3 min-w-150px text-start ps-2">CORREO</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">OFICINA</th>
                                    <th className="p-0 pb-3 min-w-100px text-start ps-2">PUESTO</th>
                                    <th className="p-0 pb-3 min-w-120px text-start ps-2">TELÉFONO</th>
                                    <th className="p-0 pb-3 min-w-120px text-end pe-2">ACCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length === 0 && (
                                    <tr>
                                        <td className="px-6 py-3 text-center" colSpan="7">No hay datos.</td>
                                    </tr>
                                )}
                                {rows.map((item) => (
                                    <tr key={item.id}>
                                        <td className="ps-2">
                                            <UserAvatar src={item.user?.photo_url} size={40} alt={item.user?.name || ''} />
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">
                                                {item.user?.name} {item.lastname_ap} {item.lastname_am}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.user?.email || '—'}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.office?.nombre || '—'}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.position?.nombre || '—'}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{item.phone_number || '—'}</p>
                                        </td>
                                        <td className="text-end pe-2">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light-primary"
                                                onClick={() => setSelected(item)}
                                            >
                                                Ver información
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <PaginationList links={items.links} filters={paginationFilters} />
                </div>
            </div>

            <ContactModal show={!!selected} onHide={() => setSelected(null)} item={selected} />
        </Row>
    )
}

List.layout = (page) => <Layout children={page} title="Directorio" />

export default List
